import { createSlice } from "@reduxjs/toolkit";

const initialExamGradesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  courseAndSemesterData: {}
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const examGradeSlice = createSlice({
  name: "examGrades",
  initialState: initialExamGradesState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getCourseAndSemesterData
    courseAndSemesterDataFetched: (state, action) => {
      const { isSuccess, type, entity } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.courseAndSemesterData = entity;
    },
    // getStudents
    studentsFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    // cleanCourseAndSemesterState
    courseAndSemesterStateCleaned: (state) => {
      state.courseAndSemesterData = {};
    },
    //cleanExamGradesState
    examGradesStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = undefined;
    }
  }
});